// extracted by mini-css-extract-plugin
module.exports = {"row":"PropertyDetails_row___QmRn","infoButton":"PropertyDetails_infoButton__xGjik","price":"PropertyDetails_price__xmRFv","icon":"PropertyDetails_icon__QOAGy"};